export { CampaignResolutionType } from './generated/CampaignResolutionType.js';